export function isSameDay(a: Date, b: Date) {
  return (
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate()
  );
}

/**
 * Format a timestamp as relative time (e.g., "2m ago", "Yesterday", "Dec 15")
 */
export function formatRelativeTime(timestamp: number): string {
  const now = Date.now();
  const diff = Math.max(0, now - timestamp);

  // Less than 1 minute
  if (diff < 60 * 1000) {
    return "just now";
  }

  // Less than 1 hour
  if (diff < 60 * 60 * 1000) {
    const minutes = Math.floor(diff / (60 * 1000));
    return `${minutes}m ago`;
  }

  // Less than 24 hours
  if (diff < 24 * 60 * 60 * 1000) {
    const hours = Math.floor(diff / (60 * 60 * 1000));
    return `${hours}h ago`;
  }

  // Check if yesterday
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const timestampDate = new Date(timestamp);
  timestampDate.setHours(0, 0, 0, 0);

  // Use calendar-day difference instead of dividing by 86400000,
  // which avoids DST transitions yielding fractional day counts.
  const daysDiff = Math.round(
    (today.getTime() - timestampDate.getTime()) / (24 * 60 * 60 * 1000),
  );

  if (daysDiff === 1) {
    return "Yesterday";
  }

  // Less than 7 days - show day name
  if (daysDiff < 7) {
    return new Date(timestamp).toLocaleDateString(undefined, {
      weekday: "short",
    });
  }

  // Same year - show month and day
  const thisYear = new Date().getFullYear();
  const msgYear = new Date(timestamp).getFullYear();

  if (thisYear === msgYear) {
    return new Date(timestamp).toLocaleDateString(undefined, {
      month: "short",
      day: "numeric",
    });
  }

  // Different year - show full date
  return new Date(timestamp).toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}
